module.exports = __webpack_public_path__ + "./img-sophia_36bb5ed5651eeb8bf81d272f517a8e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-sophia.png
// module id = 467
// module chunks = 0